import { Component } from '@angular/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-rootfdas',
  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'EInvoice-Portal';
}
